<template>
    <div class="sendMsg">
        <span @click="addeNode">新增</span>
        <span v-show="subData && !subData.isRoot" @click="editNode">编辑</span>
        <span v-show="subData && !subData.isRoot" @click="deleteNode">删除</span>
    </div>
</template>
<script>
import { deleteGzwz } from "@/api/equipmentDic/index"
import addCom from "./add.vue"
import editCom from "./edit.vue"
export default {
    props: ["subData"],
    data() {
        return {
        };
    },
    methods: {
        addeNode() {
            this.closeMsg();
            this.$dialog.open({
                title: "新增故障位置",
                shade:true,
                theme: "feature-dialog",
                area: {
                    height: "300px",
                    width: "680px",
                },
                content: {
                    type: "vue",
                    subCom: addCom,
                    subData: this.subData
                },
            });
        },
        editNode() {
            this.closeMsg();
            this.$dialog.open({
                title: "编辑故障位置",
                shade:true,
                theme: "feature-dialog",
                area: {
                    height: "180px",
                    width: "680px",
                },
                location: {
                    top: "100px",
                },
                content: {
                    type: "vue",
                    subCom: editCom,
                    subData: this.subData
                },
            });
        },
        deleteNode() {
            this.closeMsg();
            this.$confirm("是否删除该条数据？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var id = this.subData.obj.id;
                    deleteGzwz(id).then(() => {
                        this.$message({
                            showClose: true,
                            message: "删除成功！",
                            type: "success",
                            duration: 3 * 1000,
                        });
                        this.$bus.$emit("faultLocation-list");
                    });
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        type: "info",
                        message: "本次操作已取消！",
                        duration: 3 * 1000,
                    });
                });
        },
        closeMsg() {
            if (window.rightIns) {
                this.$dialog.close(window.rightIns);
                window.rightIns = undefined;
            }
        },
    }
}
</script>
    
<style scoped lang="scss">
.sendMsg {
    padding: 8px 10px;
    display: flex;
    flex-direction: column;

    span {
        color: #303133;
        cursor: pointer;
        font-size: 14px;
        border-bottom: #E4E7ED solid 1px;
        margin: 2px 0;
        padding-bottom: 2px;
        padding-left: 8px;
        padding-right: 8px;

        &:hover {
            color: #1da373;
        }
    }
}
</style>